import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight, Loader2 } from "lucide-react";

export function WizardSteps({ steps, step, onGo, testId = "ws-steps", tabTestId = "ws-step-tab" }) {
  return (
    <ol className="flex items-start gap-2 mb-1" data-testid={testId}>
      {steps.map((t, i) => (
        <li key={t} className="flex-1 min-w-0">
          <button type="button" onClick={() => onGo(i)} disabled={i >= step} data-testid={`${tabTestId}-${i + 1}`}
            className="w-full text-left disabled:cursor-default">
            <div className={`h-1.5 rounded-full transition-colors duration-300 ${i <= step ? "bg-primary" : "bg-muted"}`} />
            <p className={`mt-1.5 text-[11px] leading-tight ${i === step ? "font-semibold text-foreground" : "text-muted-foreground"}`}>
              <span className="tabular-nums">{i + 1}.</span> {t}
            </p>
          </button>
        </li>
      ))}
    </ol>
  );
}

export function WizardFooter({ step, total, onBack, onNext, onFinish, nextDisabled, finishDisabled, loading, finishLabel,
  ids = { back: "ws-back", next: "ws-next", finish: "ws-save" }, hint }) {
  const last = step >= total - 1;
  return (
    <div className="pt-2">
      <div className="flex flex-row gap-2 justify-between">
        {step > 0
          ? <Button variant="outline" onClick={onBack} data-testid={ids.back}><ChevronLeft className="w-4 h-4 mr-1" />Atrás</Button>
          : <span />}
        {!last ? (
          <Button onClick={onNext} disabled={nextDisabled} data-testid={ids.next}>Siguiente<ChevronRight className="w-4 h-4 ml-1" /></Button>
        ) : (
          <Button onClick={onFinish} disabled={loading || finishDisabled} data-testid={ids.finish}>
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : finishLabel}
          </Button>
        )}
      </div>
      {hint && <p className="text-[11px] text-muted-foreground text-right mt-1.5" data-testid={`${ids.next}-hint`}>{hint}</p>}
    </div>
  );
}
